<template>
    <div>
      <navigation-bar Back/>
      <div class="coupon-new main">
        <div class="cart-list sticky-oin">
            <div class="li">
                訂單小計
                <span class="float-right">$ {{originTotalPrice}}</span>
            </div>
            <div class="li" @click="dialogIntro = true">
                優惠合計<i class="el-icon-question i-info"/>
                <span class="float-right red">$ {{couponPrice}}</span>
            </div>
            <div class="li">
                總付款額<span class="red ml-2">(依購物車金額為主)</span>
                <span class="float-right">$ {{originTotalPrice - couponPrice}}</span>
            </div>
            <div class="text-center mt-3">
                <el-button @click="submitCoupon()" round>送出</el-button>
            </div>
        </div>
        <h4 v-if="ableUseCouponList.length === 0" class="title gray mt-3">目前沒有可使用的優惠券</h4>
        <PickCouponCover :list="ableUseCouponList"
                        :amount="couponChoiceListInputArr"
                        :disable="disbaleCouponChoiceList"
                        :couponChoice="couponChoiceList"
                        @triggerEvent="pickCouponCoverEvent"
                        v-else/>

        <h4 v-if="notAbleUseCouponList.length > 0" class="title gray mt-3">無法使用的優惠券</h4>
        <PickCouponCover :list="notAbleUseCouponList"
                       :couponChoice="couponChoiceList"
                       :useType="false"/>

        <comm-dialog :value="isShowDialog"
                     :outerContent="commDialogOuterContent"
                     :isCancel="isCancel"
                     @result="onDialogResult"/>

        <el-dialog
                :visible.sync="dialogIntro"
                custom-class="commDialog"
                @close="closeLimitDialog"
                width="80%">
            <div class="container">
                <div class="outer-content">優惠合計說明</div>
                <el-divider class="m-0"></el-divider>
                <div class="main-content text-left">
                    {{discountLimitCase === 1 ? "優惠上限為" : "優惠折抵上限為訂單金額的"+discountLimitAmount+"%("}}<span class="red">${{discountLimitPrice}}</span>{{discountLimitCase === 1 ? "" : ")"}}。若超過上限，恕不退返票券金額。
                </div>
                <div>
                    <span class="red ml-2">(依購物車金額為主)</span>
                </div>
            </div>
        </el-dialog>

      </div>
    </div>
</template>

<script>
    import {notNull} from '@/util/common';
    import CommDialog from "@/components/CommDialog";
    import * as constDefine from '@/store/constDefine';
    import PickCouponCover from '@/components/PickCouponCover';

    export default {
        name: "OrderCouponList",
        components: {
            CommDialog,
            PickCouponCover,
        },
        data() {
            return {
                couponList: this.$route.params.couponList,                      //全部的優惠券
                couponChoiceList: this.$route.params.couponChoiceList,          //已選擇的優惠券
                couponChoiceListItem: this.$route.params.couponChoiceListItem,  //已選擇的優惠券
                couponChoiceListInputArr: [],               //符合input的v-model的輸入格式
                oldValueCouponChoiceListInputArr: null,     //input的v-model舊的值暫存（watch無法捕捉這個欄位的oldValue）
                disbaleCouponChoiceList: [],                //被disable的couponChoiceList
                // originTotalPrice: this.$route.params.originTotalPrice,              //小計 改用優惠前小計
                originTotalPrice: this.$store.state.cartPageSnapshot.oldOriginTotalPrice, //用優惠前小計
                calculatorCouponPrice: this.$route.params.calculatorCouponPrice,    //經過優惠券計算金額
                discountLimit: this.$route.params.discountLimit,                    //優惠券使用上限設定
                isTriggerSubmitCoupon: this.$route.params.isTriggerSubmitCoupon || false,
                discountLimitPrice: 0,      //優惠券使用達上限對話框顯示上限金額
                discountLimitCase: 0,       //優惠券使用達上限對話框顯示上限類型 0:無限制、1:金額上限、2:折扣上限
                discountLimitAmount: 0,     //優惠券使用上限對話框顯示上限數字（金額限制顯示金額、折扣上限顯示比例）
                radioTake: this.$route.params.radioTake,    //1是自取，2是外送
                couponPrice: 0,             //優惠合計
                storeInfo: this.$route.params.storeInfo,    //店家資訊
                ableUseCouponList: [],      //可使用的優惠券
                notAbleUseCouponList: [],   //無法使用的優惠券
                scrollTop: '',
                scrollHeight: '',
                isShowDialog: false,
                isCancel: true,
                backtrackfunc: null,        //回溯
                commDialogOuterContent: '', //對話框文字
                CommDialogConfirm: null,    //對話框按確定
                //優惠卷數量
                num:  0,
                //優惠合計說明彈框
                dialogIntro: false,
                timeoutID: 0,
                isPrevention: false,        //預防isShowDialog失效
                useRewardPointIdList: this.$store.state.cartPageSnapshot.orderRewardPointInfo.useRewardPointIdList,
                choicePosFoodObject: {},
                requirePosFoodObject: {},
                originShoppingCartMealChoiceList: [],
                isCouponChoiceListInputArrUpdate: false,
            }
        },
        created() {
            // 有快照且是來自'OrderCouponDetail'的話就用快照的資料，不是的話就重撈
            if ((notNull(this.fromRoute) && ['OrderCouponDetail'].indexOf(this.fromRoute.name) === -1) || !notNull(this.$store.state.pageSnapshot[this.$route.name])) {
                this.setupData();
            } else {
                let snapshotData = this.$store.state.pageSnapshot[this.$route.name];
                for (const key in snapshotData) {
                    if (Object.hasOwnProperty.call(snapshotData, key)) {
                        const element = snapshotData[key];
                        this[key] = element;
                    }
                }
                // 渲染完成後等一下才捲到目標位置
                this.$nextTick(function () {
                    if (this.scrollTop !== '') {
                        let finish = false;
                        let count = 0;
                        this.timeoutID = setInterval(() => {
                            if (this.scrollHeight === document.querySelector('.coupon-new').scrollHeight) {
                                document.querySelector('.coupon-new').scrollTo(0, this.scrollTop);
                                this.scrollTop = '';
                                finish = true;
                            }
                            count = count + 1;
                            if (finish || count > 200) {
                                window.clearInterval(this.timeoutID);
                            }
                        }, 20);
                    }
                });
                // // 不管有沒有用到快照都要清掉
                this.$store.commit("savePageSnapshot", {routeName: this.$route.name, variable: undefined});
            }
            // 找出已選擇的選項
            let tempChoice = {};
            this.couponChoiceList.forEach(code => {
                tempChoice[code] = 1;
            })
            this.couponChoiceListItem.forEach(item => {
                if (notNull(item.choiceAmount) && item.choiceAmount > 0) {
                    tempChoice[item.code] = item.choiceAmount;
                }
            });
            this.ableUseCouponList.forEach((item, index) => {
                if (notNull(tempChoice[item.code]) && tempChoice[item.code] > 0) {
                    this.couponChoiceListInputArr[index] = tempChoice[item.code];
                }
            });
        },
        mounted() {
            this.setDiscountLimitDialog();
        },
        destroyed() {
            if (this.timeoutID !== 0) {
                window.clearInterval(this.timeoutID);
            }
        },
        methods: {
            setupData() {
                this.choicePosFoodObject = {}
                this.originShoppingCartMealChoiceList = []
                try {
                    this.$store.state.cartPageSnapshot.shoppingCartMealChoiceList.forEach(item => {
                        if (!item.isNewItem) {
                            if (typeof item.originInfo !== "undefined") {
                                item = JSON.parse(JSON.stringify(item.originInfo))
                            }

                            this.originShoppingCartMealChoiceList.push(item)

                            if (Object.hasOwnProperty.call(this.choicePosFoodObject, item.meal_id)) {
                                this.choicePosFoodObject[item.meal_id].amount += item.amount
                            } else {
                                this.choicePosFoodObject[item.meal_id] = {
                                    amount: item.amount,
                                }
                            }
                        }
                    })

                    this.$store.state.cartPageSnapshot.shoppingCartMealData.forEach(item => {
                        let dataJson = JSON.parse(item.data_json)
                        this.choicePosFoodObject[item.meal_id].posFoodInfo = dataJson.posFoodInfo
                    })
                } catch (err) {
                    this.choicePosFoodObject = {}
                }

                // 區分消費金額是否有到使用coupon的標準
                this.couponList.forEach((element, index) => {
                    let requirePosFoodId = 0
                    if (element.couponTypeId === 1) {
                        requirePosFoodId = element.freebiePosFoodId
                    } else if (element.couponTypeId === 3) {
                        requirePosFoodId = element.purchasePosFoodId
                    }

                    let notAbleUseType = 0
                    if (element.posUseType === 2 && element.posUseAmount > this.originTotalPrice) {
                        notAbleUseType = 1
                    } else if (!element.isStarted) {
                        notAbleUseType = 2
                    } else if (!element.isDiscountShare && this.useRewardPointIdList.length > 0) {
                        notAbleUseType = 3
                    } else if (requirePosFoodId > 0 && element.posUseConditionType === 2 && !Object.hasOwnProperty.call(this.choicePosFoodObject, requirePosFoodId)) {
                        notAbleUseType = 4
                    }

                    if (notAbleUseType > 0) {
                        element.notAbleUseType = notAbleUseType
                        this.notAbleUseCouponList.push(element);
                    } else {
                        element.posFoodInfo = {}
                        if (requirePosFoodId > 0) {
                            if (Object.hasOwnProperty.call(this.choicePosFoodObject, requirePosFoodId)) {
                                element.posFoodInfo = this.choicePosFoodObject[requirePosFoodId].posFoodInfo
                            }
                        }

                        element.requirePosFoodId = requirePosFoodId
                        this.ableUseCouponList.push(element);
                        this.couponChoiceListInputArr.push(0);
                    }
                });
                if (this.isTriggerSubmitCoupon) {
                    this.$nextTick(() => {
                        this.submitCoupon()
                    })
                }
            },
            setDiscountLimitDialog() {
                let self = this
                //自取
                if (Number(self.radioTake) === constDefine.RADIO_TAKE.takeout) {

                    self.discountLimitCase = self.discountLimit.takeoutDiscountLimitType;
                    if (self.discountLimit.takeoutDiscountLimitType === constDefine.DISCOUNT_LIMIT.limitPrice) {
                        //金額限制
                        self.discountLimitPrice = self.discountLimit.takeoutDiscountLimitPrice;
                        self.discountLimitAmount = self.discountLimit.takeoutDiscountLimitPrice;
                    } else if (self.discountLimit.takeoutDiscountLimitType === constDefine.DISCOUNT_LIMIT.limitPercentage) {
                        //比例限制
                        self.discountLimitPrice = Math.round(self.originTotalPrice * (self.discountLimit.takeoutDiscountLimitPercentage / 100));
                        self.discountLimitAmount = self.discountLimit.takeoutDiscountLimitPercentage;
                    }
                    //外帶
                } else if (Number(self.radioTake) === constDefine.RADIO_TAKE.delivery) {

                    self.discountLimitCase = self.discountLimit.deliveryDiscountLimitType;
                    if (self.discountLimit.deliveryDiscountLimitType === constDefine.DISCOUNT_LIMIT.limitPrice) {
                        //金額限制
                        self.discountLimitPrice = self.discountLimit.deliveryDiscountLimitPrice;
                        self.discountLimitAmount = self.discountLimit.deliveryDiscountLimitPrice;
                    } else if (self.discountLimit.deliveryDiscountLimitType === constDefine.DISCOUNT_LIMIT.limitPercentage) {
                        //比例限制
                        self.discountLimitPrice = Math.round(self.originTotalPrice * (self.discountLimit.deliveryDiscountLimitPercentage / 100));
                        self.discountLimitAmount = self.discountLimit.deliveryDiscountLimitPercentage;
                    }
                }
            },
            // 確定送出事件
            submitCoupon() {
                let tmpShoppingCartMealChoiceList = []
                this.originShoppingCartMealChoiceList.forEach(item => {
                    let isNew = false
                    let newItemList = []
                    let originInfo = JSON.parse(JSON.stringify(item))

                    if (Object.hasOwnProperty.call(this.requirePosFoodObject, item.meal_id)) {
                        if (this.requirePosFoodObject[item.meal_id].totalRemainAmount > 0) {
                            let posFoodInfo = this.choicePosFoodObject[item.meal_id].posFoodInfo || {}
                            let cost = posFoodInfo.onlineOrderPrice || 0
                            let addPrice = 0
                            //有加價註記時
                            if ((item.amount * cost) < item.choicePrice) {
                                addPrice = ((item.choicePrice - (item.amount * cost)) / item.amount)
                            }

                            item.originInfo = JSON.parse(JSON.stringify(originInfo))

                            this.requirePosFoodObject[item.meal_id].couponListInfoList.some(couponListItem => {
                                let temp = {
                                    "useName": couponListItem.couponTypeName.slice(0, 2),
                                    "couponName": couponListItem.couponListName,
                                    "couponDiscount": couponListItem.purchasePrice,
                                    "posFoodId": item.meal_id
                                }

                                if (couponListItem.choiceAmount > 0) {
                                    if (item.amount > couponListItem.choiceAmount) {
                                        item.isDisableModify = true
                                        item.amount -= couponListItem.choiceAmount
                                        item.choicePrice -= (cost + addPrice) * couponListItem.choiceAmount
                                        if (item.choicePrice < 0) {
                                            item.choicePrice = 0
                                        }

                                        isNew = true

                                        let newItem = JSON.parse(JSON.stringify(originInfo))
                                        newItem.amount = couponListItem.choiceAmount
                                        newItem.isCouponUse = true
                                        newItem.isDisableModify = true
                                        newItem.executeType = 3
                                        newItem.executeData = JSON.stringify(temp)
                                        newItem.couponTypeId = couponListItem.couponTypeId
                                        newItem.choicePrice = addPrice * couponListItem.choiceAmount
                                        newItem.originInfo = undefined
                                        newItem.isNewItem = true

                                        newItemList.push(newItem)

                                        this.requirePosFoodObject[item.meal_id].totalRemainAmount -= item.amount
                                        couponListItem.choiceAmount -= item.amount
                                    } else {
                                        item.isCouponUse = true
                                        item.isDisableModify = true
                                        item.executeType = 3
                                        item.executeData = JSON.stringify(temp)
                                        item.couponTypeId = couponListItem.couponTypeId
                                        item.choicePrice -= cost * item.amount
                                        if (item.choicePrice < 0) {
                                            item.choicePrice = 0
                                        }

                                        this.requirePosFoodObject[item.meal_id].totalRemainAmount -= item.amount
                                        couponListItem.choiceAmount -= item.amount
                                        return true
                                    }
                                }
                            })
                        }
                    }

                    tmpShoppingCartMealChoiceList.push(item)

                    if (isNew && newItemList.length > 0) {
                        tmpShoppingCartMealChoiceList = tmpShoppingCartMealChoiceList.concat(newItemList)
                    }
                })

                this.$store.commit("updateShoppingCartMealChoiceList", JSON.parse(JSON.stringify(tmpShoppingCartMealChoiceList)));
                this.$store.commit("updateCartcouponChoiceListItem", JSON.parse(JSON.stringify(this.couponChoiceListItem)));
                this.$router.go(-1);
            },
            toCouponDetail(item, ableUse, disAbled, index){
                disAbled = disAbled !== undefined ? disAbled : false;
                let isUsed = this.couponChoiceList.indexOf(item.code) >= 0 || item.choiceAmount > 0;
                this.$router.push({name: 'OrderCouponDetail',query:{couponId:item.couponListId, ableUse: ableUse, isUsed: isUsed, disAbled: disAbled, choiceCode: item.code}});
            },
            onDialogResult(result) {
                if (!result) {
                    if (typeof this.backtrackfunc === "function") {
                        this.backtrackfunc();
                    }
                } else if (notNull(this.CommDialogConfirm)) {
                    this.CommDialogConfirm();
                    this.CommDialogConfirm = null;
                }
                this.isShowDialog = false;
                this.isCancel = true
            },
            closeLimitDialog() {
                if (typeof this.backtrackfunc === "function") {
                    this.backtrackfunc();
                }
                this.dialogIntro = false;
            },
            pickCouponCoverEvent(obj) {
                let self = this;
                let event = obj.event;

                if (event === "UpdateCouponChoiceListInputArr") {
                    self.isCouponChoiceListInputArrUpdate = true
                    self.couponChoiceListInputArr = obj.couponChoiceListInputArr
                }
            },
        },
        watch:{
            couponChoiceListInputArr: {
                handler: function (newVal, oldVal) {
                    //值有異動才動作
                    if (JSON.stringify(newVal) !== JSON.stringify(this.oldValueCouponChoiceListInputArr)) {
                        let self = this;
                        let checkCumulativeTypeList = {}
                        let isAdd = true

                        if (Array.isArray(newVal) && Array.isArray(oldVal)) {
                            let newSumAmount = newVal.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
                            let oldSumAmount = oldVal.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
                            if (oldSumAmount > newSumAmount) {
                                isAdd = false
                            }
                        }

                        this.requirePosFoodObject = {}
                        //確定暫存值不是初始值才動作
                        if (this.oldValueCouponChoiceListInputArr !== null) {
                            //把選擇狀態轉成couponChoiceListItem
                            let temp = this.originTotalPrice;
                            let oldValueCouponChoiceListInputArr = this.oldValueCouponChoiceListInputArr;
                            let isExceed = false
                            let discountCount = 0
                            let message = ""
                            this.couponChoiceListItem = [];
                            this.ableUseCouponList.forEach((item, index) => {
                                let couponListId = "couponListId_" + item.couponListId
                                if (this.couponChoiceListInputArr[index] > 0) {
                                    item.choiceAmount = this.couponChoiceListInputArr[index];
                                    this.couponChoiceListItem.push(item);
                                    if (item.posUseType === 2) {
                                        let newItem = JSON.parse(JSON.stringify(item))
                                        if (typeof checkCumulativeTypeList[couponListId] === "undefined") {
                                            newItem.totalChoiceAmount = item.choiceAmount;
                                        } else {
                                            newItem.totalChoiceAmount = checkCumulativeTypeList[couponListId].totalChoiceAmount + item.choiceAmount
                                        }
                                        checkCumulativeTypeList[couponListId] = newItem
                                    }

                                    if (item.requirePosFoodId > 0) {
                                        let requirePosFoodInfo = this.requirePosFoodObject[item.requirePosFoodId] || {}
                                        let checkAmount = item.posUseConditionType === 2 ? item.choiceAmount : 0

                                        let couponListObject = {
                                            couponListId: item.couponListId,
                                            couponListName: item.name,
                                            choiceAmount: item.choiceAmount,
                                            couponTypeId: item.couponTypeId,
                                            couponTypeName: item.couponTypeName,
                                            purchasePrice: item.purchasePrice || 0,
                                            posUseConditionType: item.posUseConditionType,
                                        }

                                        if (Object.hasOwnProperty.call(this.requirePosFoodObject, item.requirePosFoodId)) {
                                            let couponListIndex = requirePosFoodInfo.couponListIdList.indexOf(item.couponListId)

                                            requirePosFoodInfo.totalChoiceAmount += item.choiceAmount
                                            requirePosFoodInfo.totalRemainAmount += item.choiceAmount
                                            requirePosFoodInfo.totalCheckAmount += checkAmount

                                            if (couponListIndex === -1) {
                                                requirePosFoodInfo.couponListIdList.push(item.couponListId)
                                                requirePosFoodInfo.couponListInfoList.push(couponListObject)
                                            } else {
                                                requirePosFoodInfo.couponListInfoList[couponListIndex].choiceAmount += item.choiceAmount
                                            }
                                        } else {
                                            this.requirePosFoodObject[item.requirePosFoodId] = {
                                                posFoodName: item.posFoodName,
                                                totalChoiceAmount: item.choiceAmount,
                                                totalRemainAmount: item.choiceAmount,
                                                totalCheckAmount: checkAmount,
                                                couponListIdList: [item.couponListId],
                                                couponListInfoList: [couponListObject],
                                            }
                                        }
                                    }

                                    if (item.discountType === 2 && item.choiceAmount > 0) {
                                        discountCount += item.choiceAmount
                                    }
                                } else {
                                    item.choiceAmount = 0
                                    if (this.couponChoiceList.indexOf(item.code)) {
                                        this.couponChoiceList.splice(this.couponChoiceList.indexOf(item.code), 1);
                                    }
                                }
                            });

                            Object.keys(checkCumulativeTypeList).forEach(index => {
                                let item = checkCumulativeTypeList[index]
                                let requestAmount = (Math.ceil(item.totalChoiceAmount / item.posUsePieces) * item.posUseAmount)
                                if (item.posUseCumulativeType === 1 && item.totalChoiceAmount > item.posUsePieces) {
                                    message = item.name + "一次只可使用" + item.posUsePieces + "張"
                                    isExceed = true
                                } else if (item.posUseCumulativeType === 2 && requestAmount > this.originTotalPrice) {
                                    message = "使用" + item.totalChoiceAmount + "張" + item.name + "需消費滿" + requestAmount + "元"
                                    isExceed = true
                                }
                            })

                            Object.keys(this.requirePosFoodObject).forEach(index => {
                                let item = this.requirePosFoodObject[index]

                                let posFoodAmount = 0
                                if (Object.hasOwnProperty.call(this.choicePosFoodObject, index)) {
                                    posFoodAmount = this.choicePosFoodObject[index].amount || 0
                                }

                                if (item.totalCheckAmount > posFoodAmount) {
                                    message = `使用該優惠需消費${item.totalCheckAmount}份「${item.posFoodName}」`
                                    isExceed = true
                                }
                            })

                            //計算折扣金額
                            temp = this.calculatorCouponPrice(temp, this.couponChoiceListItem);
                            this.couponPrice = this.originTotalPrice - temp;

                            if (discountCount > 1) {
                                message = "一筆訂單僅能用一張折扣券"
                                isExceed = true
                            }

                            if (isExceed) {
                                this.commDialogOuterContent = message;
                                this.isShowDialog = true;
                                this.isCancel = false;

                                this.backtrackfunc = function () {
                                    this.isPrevention = true;
                                    this.couponChoiceListInputArr = JSON.parse(JSON.stringify(oldValueCouponChoiceListInputArr));
                                }
                                this.CommDialogConfirm = function () {
                                    if (typeof this.backtrackfunc === "function") {
                                        this.backtrackfunc();
                                    }
                                }
                            } else if (temp === 0) {
                                //人為異動且是新增數量才有彈窗，immediate觸發或減少數量就不用
                                if (this.isCouponChoiceListInputArrUpdate && isAdd) {
                                    this.commDialogOuterContent = '已超出可抵用金額囉！確認是否使用優惠票券？';
                                    //避免因為關閉後又馬上執行復原couponChoiceListInputArr導致dialog異常
                                    if (!this.isPrevention) {
                                        this.isShowDialog = true;
                                    }

                                    this.backtrackfunc = function () {
                                        this.isPrevention = true
                                        this.couponChoiceListInputArr = JSON.parse(JSON.stringify(oldValueCouponChoiceListInputArr));
                                    }
                                }
                            } else if ((() => {
                                let check = this.couponChoiceListItem.reduce(function (a, b) {
                                    if (a.couponListId.indexOf(b.couponListId) === -1) {
                                        a.couponListId.push(b.couponListId);
                                    }
                                    if (b.isDiscountShare === 0) {
                                        a.count += 1;
                                    }
                                    return a;
                                }, {couponListId: [], count: 0});
                                return check.count > 0 && check.couponListId.length > 1
                            })()) {
                                let diffItem = null;
                                this.couponChoiceListInputArr.forEach((item, index) => {
                                    if (oldValueCouponChoiceListInputArr[index] <= 0 && item > 0) {
                                        diffItem = this.ableUseCouponList[index];
                                    }
                                });
                                if (diffItem.isDiscountShare === 0) {
                                    this.commDialogOuterContent = '目前選擇的票券無法與其他優惠共用喔';
                                } else {
                                    this.commDialogOuterContent = '此票券無法與其他優惠一起使用喔';
                                }
                                this.isShowDialog = true;
                                this.isCancel = false;
                                this.backtrackfunc = function () {
                                    this.isPrevention = true;
                                    this.couponChoiceListInputArr = JSON.parse(JSON.stringify(oldValueCouponChoiceListInputArr));
                                }
                                this.CommDialogConfirm = function () {
                                    if (typeof this.backtrackfunc === "function") {
                                        this.backtrackfunc();
                                    }
                                }
                            } else if (
                                function () {
                                    //不是無限制並且超出限制
                                    if (self.discountLimitCase !== 0 && self.couponPrice > self.discountLimitPrice) {
                                        self.couponPrice = self.discountLimitPrice
                                        return true;
                                    } else {
                                        return false;
                                    }
                                }()
                            ) {
                                //目前看起來超過金額限制不用擋，先開起來放
                                this.backtrackfunc = function () {
                                    // this.couponChoiceListInputArr = JSON.parse(JSON.stringify(oldValueCouponChoiceListInputArr));
                                }
                                this.dialogIntro = true;
                            }
                        }
                        this.isPrevention = false
                        this.oldValueCouponChoiceListInputArr = JSON.parse(JSON.stringify(newVal));
                    }
                },
                deep: true,
                immediate: true,
            },
        },
        beforeRouteEnter: function (to, from, next) {
            next(
                vm => {
                    // vm就是出去的this，先把來的路由存起來，出去就抓不到了？
                    vm.fromRoute = from;
                }
            );
        },
        beforeRouteLeave: function (to, from, next) {
            // 如果是'OrderCouponDetail'的話就記住快照
            if (['OrderCouponDetail'].indexOf(to.name) !== -1) {
                let variable = {};
                for (const key in this._data) {
                    if (Object.hasOwnProperty.call(this._data, key)) {
                        const element = this._data[key];
                        variable[key] = element;
                    }
                }
                variable.scrollTop = document.querySelector('.coupon-new').scrollTop;
                variable.scrollHeight = document.querySelector('.coupon-new').scrollHeight;
                this.$store.commit("savePageSnapshot",
                    {
                        routeName: from.name,
                        variable: variable,
                    },
                );
            }
            next();
        },
    }
</script>
<style lang="less" scoped src="../../less/order.less"/>
<style lang="less" scoped>
    /deep/.app-header{
        @media(min-width: 1024px){
            display: block!important;
        }
        .text-left{
            display: block !important;
        }
    }
</style>